export default "__VITE_ASSET__713cda42__"